import { Button, Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import * as React from 'react';
import { useContext, useState } from 'react';
import { authAxios } from '../../services/AxiosService';
import { notifyError, notifySuccess } from '../../services/ToastService';
import { useParams } from 'react-router';
import Select from 'react-select';
import { ConfirmModal } from 'src/components/ConfirmModal/ConfirmModal';
import {
  ISupportWorkerRequestWeight,
  SupportWorkerRequestContext,
} from 'src/components/SupportRequests/SupportWorkerRequestContext';

export const RecordSupportWorkerRequestWeight: React.FC = () => {
  const params = useParams<{ supportWorkerRequestId?: string }>();
  // const domainContext = useContext(DomainContext);
  const { supportWorkerRequest, setSupportWorkerRequest } = useContext(SupportWorkerRequestContext);
  const supportWorkerRequestWeights = supportWorkerRequest.supportWorkerRequestWeights;
  const latestWeight =
    supportWorkerRequestWeights && supportWorkerRequestWeights.length > 0
      ? supportWorkerRequestWeights[supportWorkerRequestWeights.length - 1]
      : undefined;
  const [confirmSupportWorkerRequestWeightChangeModal, setConfirmSupportWorkerRequestWeightChangeModal] =
    useState(false);
  const [trySubmit, setTrySubmit] = useState(false);
  const [weight, setWeight] = useState<number | undefined>(latestWeight ? latestWeight.weight : undefined);
  const [weightNotes, setWeightNotes] = useState(latestWeight ? latestWeight.notes : '');

  const recordSupportWorkerRequestWeight = () => {
    if (weight) {
      const data = { supportWorkerRequestId: params.supportWorkerRequestId, weight: weight, notes: weightNotes };
      authAxios
        .post('/api/support-worker-requests/admin/record-support-worker-request-weight', data)
        .then((response: any) => {
          if (response.data.status === 'OK') {
            notifySuccess('Request Weight Updated.');
            setSupportWorkerRequest((r) => ({
              ...r,
              supportWorkerRequestWeights: r.supportWorkerRequestWeights.concat({
                supportWorkerRequestWeightId: response.data.supportWorkerRequestWeightId,
                weight: weight,
                notes: weightNotes,
              } as ISupportWorkerRequestWeight),
            }));
          } else {
            notifyError(response.data.errorMessage);
          }
        });
    } else {
      setTrySubmit(true);
    }
  };
  const weightOptions = [
    { val: 1, display: '1' },
    { val: 2, display: '2' },
    { val: 3, display: '3' },
    { val: 4, display: '4' },
    { val: 5, display: '5' },
    { val: 6, display: '6' },
  ];
  const dropdownSelectStyles = {
    menu: (provided: any) => ({ ...provided, zIndex: 9999 }),
  };

  console.log(supportWorkerRequestWeights);
  return (
    <>
      <Card className={'bg-primary-light'} style={{ width: '100%' }}>
        <CardHeader>Lawyer File Weight</CardHeader>
        <CardBody className={'pt-2'}>
          <Row>
            <Col md={3}>
              <FormGroup>
                <Label>Complexity</Label>
                <Select
                  styles={dropdownSelectStyles}
                  name={'Weight'}
                  options={weightOptions}
                  placeholder={'Select...'}
                  value={weightOptions.find((o) => o.val === weight)}
                  onChange={(value: any) => {
                    setWeight(value?.val || undefined);
                  }}
                  getOptionValue={(option: any) => option.val}
                  getOptionLabel={(option: any) => option.display}
                />
                {trySubmit && !weight && (
                  <span style={{ fontSize: 13, color: '#B22222' }}>This field is mandatory</span>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Notes</Label>
                <Input
                  value={weightNotes}
                  type={'text'}
                  name={'Notes'}
                  autoComplete={'off'}
                  onChange={(e: any) => setWeightNotes(e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col sm={3}>
              <FormGroup>
                <Button
                  style={{ marginTop: '27px' }}
                  color={'primary'}
                  onClick={() => setConfirmSupportWorkerRequestWeightChangeModal(true)}
                  disabled={latestWeight ? latestWeight?.weight === weight : false}
                >
                  Update Request Complexity
                </Button>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <ConfirmModal
        isOpen={confirmSupportWorkerRequestWeightChangeModal}
        title={'Change Lawyer File Weight'}
        onConfirm={() => {
          setConfirmSupportWorkerRequestWeightChangeModal(false);
          recordSupportWorkerRequestWeight();
        }}
        onCancel={() => setConfirmSupportWorkerRequestWeightChangeModal(false)}
        confirmButton={'Update'}
      >
        <div>Are you sure you want to change the weight of this request?</div>
      </ConfirmModal>
    </>
  );
};
